import { FormControl, Validators } from "@angular/forms";

export class mdlUnsubscribeReasonsRes {
   public UnsubscribeList:Array<UnsubscribeResMdl>=new Array<UnsubscribeResMdl>();  
   public st: mdlStatus = new mdlStatus(); // ✅ Single object, not array
}
export class UnsubscribeResMdl {
    code: number;
    descEng: string;
    descAr: string;
}
export class mdlStatus {
    StatusCode: string;
    StatusDesc: string;
    StatusDescAr: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/UnsubscribeMdl.ts